var map = {
	"./slogn-cn.png": "mfh6",
	"./slogn-de.png": "1j1C",
	"./slogn-en.png": "FpEj",
	"./slogn-es.png": "CPlP",
	"./slogn-fr.png": "TlC+",
	"./slogn-pt.png": "lcC1"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "afuD";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer1/slogn ^\.\/slogn\-.*\.png$
// module id = afuD
// module chunks = 1